import React from 'react'
import Slide from '../components/Slide'
import MainInfo from '../components/MainInfo'
import Products from './Products'
import styles from '../components/mainInfo.module.css'
import Contacts from '../components/Contacts'

export default function Home() {
  return (
    <div>
        <Slide />
        <div className={styles['background-gradient']}>
          <MainInfo/>
          <Products/>
        </div>
        <Contacts />
    </div>
  )
}
